<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 27.3.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<svg version="1.1" id="Angry" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
<style type="text/css">
	.stAngry1{fill:#302C3B;}
	.stAngry2{fill:#FF9C48;enable-background:new    ;}
	.stAngry3{fill:#302C3B;enable-background:new    ;}
</style>
<path class="stAngry1" d="M229.1,208.8c8.3,2.8,12,11.9,10.1,20.3c-2.8,8.3-11.9,12-20.3,10.1l-10.8-3.6c0.2,1.4,0.3,2.9,0.3,4.4
	c0,17.7-14.4,32-32,32c-17.7,0-32-14.3-32-32c0-8.8,3.5-16.8,9.3-22.6l-30.8-10.2c-8.3-2.8-12.9-11.9-10.1-20.3
	c2.8-8.3,11.9-12.9,20.3-10.1L229.1,208.8z M358.9,217.2c5.8,5.8,9.5,13.9,9.5,22.8c0,17.7-14.4,32-32,32c-17.7,0-32-14.3-32-32
	c0-1.6,0.1-3.2,0.3-4.7l-11.6,3.9c-8.4,1.9-17.5-1.8-20.3-10.1c-2.8-8.4,1.8-17.5,10.1-20.3l96-32c8.4-2.8,17.5,1.8,20.3,10.1
	c1.9,8.4-1.8,17.5-10.1,20.3L358.9,217.2z"/>
<path class="stAngry2" d="M512,256c0,141.4-114.6,256-256,256S0,397.4,0,256S114.6,0,256,0S512,114.6,512,256z M339.9,373.3
	C323.8,355.4,295.7,336,256,336s-67.8,19.4-83.9,37.3c-5.9,6.6-5.4,15.8,1.2,22.6c6.6,5.9,15.8,5.4,22.6-1.2
	c11.7-13,31.6-26.7,59.2-26.7c29.4,0,49.3,13.7,61,26.7c5.9,6.6,16,7.1,22.6,1.2C345.3,389.1,345.8,379.9,339.9,373.3L339.9,373.3z
	 M176.4,272c17.6,0,32-14.3,32-32c0-1.5-0.1-3-0.3-4.4l10.8,3.6c8.4,1.9,17.5-1.8,20.3-10.1c1.9-8.4-1.8-17.5-10.1-20.3l-96-32
	c-8.4-2.8-17.5,1.8-20.3,10.1c-2.8,8.4,1.8,17.5,10.1,20.3l30.8,10.2c-5.8,5.8-9.3,13.8-9.3,22.6C144.4,257.7,158.7,272,176.4,272z
	 M358.9,217.2l30.2-10c8.3-2.8,12-11.9,10.1-20.3c-2.8-8.3-11.9-12.9-20.3-10.1l-96,32c-8.3,2.8-12.9,11.9-10.1,20.3
	c2.8,8.3,11.9,12,20.3,10.1l11.6-3.9c-0.2,1.5-0.3,3.1-0.3,4.7c0,17.7,14.3,32,32,32c17.6,0,32-14.3,32-32
	C368.4,231.1,364.7,223,358.9,217.2L358.9,217.2z"/>
<path class="stAngry3" d="M339.9,373.3C323.8,355.4,295.7,336,256,336s-67.8,19.4-83.9,37.3c-5.9,6.6-5.4,15.8,1.2,22.6
	c6.6,5.9,15.8,5.4,22.6-1.2c11.7-13,31.6-26.7,59.2-26.7c29.4,0,49.3,13.7,61,26.7c5.9,6.6,16,7.1,22.6,1.2
	C345.3,389.1,345.8,379.9,339.9,373.3L339.9,373.3z"/>
</svg>
